import { createStore } from 'vuex';
import { queryUserGameInfo } from '@/api/user';

export default createStore({
  state: {
    userInfo: {},
    updateLock: false, //用户游戏信息更新锁
    gameInfo: {
      location: 'hospital', //当前地图位置
    },
    npc: [],
    place: [],
    pet: {},
  },
  getters: {},
  mutations: {
    update(state, { payload: { key, value } }) {
      state[key] = { ...state[key], ...value };
    },
    set(state, { payload: { key, value } }) {
      state[key] = value;
    },
    setGameInfo(state, { payload: { npc, place, pet } }) {
      state.npc = npc;
      state.place = place;
      state.pet = pet;
    },
  },
  actions: {
    updateUserGameInfo({ state }) {
      if (state.updateLock) return;
      state.updateLock = true;
      queryUserGameInfo()
        .then((res) => {
          state.userInfo = { ...state.userInfo, ...res.data };
          state.updateLock = false;
        })
        .catch((err) => {
          state.updateLock = false;
        });
    },
  },
  modules: {},
});
